import { Component, Input, OnInit,  TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { startOfMonth, differenceInCalendarDays } from 'date-fns';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { JobService } from '../../../../service/job.service';
import { AuthState } from '../../../../store/authInfo/auth-state';
import { JobTraceComponent } from '../../../job-trace/job-trace.component';
import { HistoryRepairRecordDetailComponent } from '../history-repair-record-detail/history-repair-record-detail.component';

@Component({
  selector: 'app-history-repair-record',
  templateUrl: './history-repair-record.component.html',
  styleUrls: ['./history-repair-record.component.less']
})
export class HistoryRepairRecordComponent implements OnInit {
@Input() equipmentId: any;
events = [];
// 分页查询条件
pageIndex: number = 1;
pageSize: number = 10;
total = 0;
loading = true;
currentSelectedJob = null;
// 查询结果
data = [];
// 用户登录信息
authState: any = null;
// 过滤条件
conditions = {date: null, allTypes: null, statusCondition: '4'}; // statusCondition = '4' 查询已完成的工单
statusCondition = 4;

validateForm!: FormGroup;
jobTypes = [];
typeMap = new Map<number, any>();
defaultRanges = { 今天: [new Date(), new Date()], 本月: [startOfMonth(new Date()), new Date()] };
disabledDate = (current: Date): boolean => {
  return differenceInCalendarDays(current, new Date()) > 0;
}
constructor(private jobService: JobService, private store: Store, private modalService: NzModalService,
            private fb: FormBuilder ) { }

ngOnInit(): void {
  this.authState = this.store.selectSnapshot<any[]>(AuthState);
  this.pageIndex = 1;
  this.pageSize = 10;
  this.authState = this.store.selectSnapshot<any[]>(AuthState);
  this.initTypeTree(this.authState.userInfo.skills);
  this.validateForm = this.fb.group({ date: null, typeId: null, levelId: null, allTypes: null });
  // this.conditions = conditions;
  // 刷新查询结果
  this.queryData();
}

async queryData() {
  if (this.authState.userInfo.skills.length > 0) {
    this.loading = true;
    const existDate = this.conditions.date != null && this.conditions.date.length >= 2;
    const existType = this.conditions.allTypes != null && this.conditions.allTypes.length > 0;
    const result = await this.jobService.getJobs(this.pageIndex,
      this.pageSize,
      existDate ? new Date(this.conditions.date[0]) : null,
      existDate ? new Date(this.conditions.date[1]) : null,
      existType ? this.conditions.allTypes : null,
      null,
      this.conditions.statusCondition, null, null, null, null, this.equipmentId);
    if (result != null) {
      this.total = result.total;
      this.data = result.data;
    }
    // 加载完成
    this.loading = false;
  } else {
    this.loading = false;
  }
}
initTypeTree(types: any[]) {
  const jobTypes = [];
  this.typeMap.clear();
  for (const type of types) {
    const node = {
      title: type.skillName,
      value: type.skillId,
      key: type.skillId,
      isLeaf: true
    };
    if (type.parentId === 0) {
      jobTypes.push(node);
    } else {
      const parent = this.typeMap.get(type.parentId);
      if (parent != null) {
        if (parent.children == null) {
          parent.children = [];
          parent.isLeaf = false;
        }
        parent.children.push(node);
      }
    }
    this.typeMap.set(type.skillId, node);
  }
  this.jobTypes = jobTypes;
}

getAllTypes(id: number): number[] {
  let types: number[] = [];
  types.push(id);
  const type = this.typeMap.get(id);
  if (type != null && type.children != null) {
    for (const child of type.children) {
      types = types.concat(this.getAllTypes(child.value));
    }
  }
  return types;
}

submitForm() {
  let allTypes: number[] = [];
  if (this.validateForm.value.typeId instanceof Array) {
    for (const id of this.validateForm.value.typeId) {
      const types: number[] = this.getAllTypes(id);
      allTypes = allTypes.concat(types);
    }
  }
  this.conditions = {date: this.validateForm.value.date, allTypes, statusCondition: '4'};
  this.queryData();
}

resetForm() {
  this.validateForm.setValue({ date: null, typeId: null, levelId: null, allTypes: null });
}
onPageIndexChange(): void {
  this.queryData();
}
traceJobInfo() {
  if (this.currentSelectedJob != null) {
    this.showInfo(this.currentSelectedJob);
  }
}
// 打开关联的工单
relateJobInfo(){
  if (this.currentSelectedJob != null) {
  }
}
showInfo(job: any) {
  this.modalService.create({
    nzTitle: '任务追踪记录',
    nzOkText: null,
    nzCancelText: '返回',
    nzBodyStyle: { padding: '10px' },
    nzWidth: 600,
    nzContent: JobTraceComponent,
    nzComponentParams: { job },
  });
}
viewJob(item: any, tplTitle: TemplateRef<{}>) {
  this.currentSelectedJob = item;
  const modal = this.modalService.create({
    nzTitle: tplTitle,
    nzContent: HistoryRepairRecordDetailComponent,
    nzStyle: { top: '20px' },
    nzWidth: 850,
    nzFooter: null,
    nzComponentParams: {
      currentJob: item,
      code: 3 // 3 表示详情,该详情界面中只会显示与当前工单相关的内容
    }
  });
}
}
